import { Component, Input, OnInit } from '@angular/core';
import { PartyType } from '@wdx/clmi/clmi-swagger-gen';
import { ModalManagementService } from '@wdx/clmi/ui';
import { Avatar } from '@wdx/clmi/utils/models';
import {
    Highlight,
    TRANSLATION_POPOVER_NO_AVATAR_AVAILABLE,
    WdxSize,
} from '@wdx/shared/utils';
import { OrganismAvatarInfoModalComponent } from '../../../components/organisms/organism-avatar-info-modal/organism-avatar-info-modal.component';
import { RandomStringPipe } from '../../../pipes/random-string.pipe';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'molecule-avatar',
    templateUrl: './molecule-avatar.component.html',
    standalone: false,
})
export class MoleculeAvatarComponent implements OnInit {
    @Input() avatar: Avatar;
    @Input() size: WdxSize = 'md';
    @Input() highlightBorder: Highlight;
    @Input() isAvatarInfoEnabled = true;
    @Input() editModalId: string;

    instanceId: string;

    readonly PARTY_TYPE = PartyType;
    readonly POPOVER_NO_AVATAR_AVAILABLE =
        TRANSLATION_POPOVER_NO_AVATAR_AVAILABLE;

    constructor(private modalManagementService: ModalManagementService) {}

    ngOnInit() {
        this.instanceId = new RandomStringPipe().transform();
    }

    openAvatarModal() {
        const avatarModal = this.modalManagementService.openModalWithComponent(
            OrganismAvatarInfoModalComponent,
        );
        avatarModal.componentInstance.avatar = this.avatar;
    }
}
